import omniDynamicFilters from 'src/store/modules/omni/omniDynamicFilter/reducers';

import * as omniDynamicFilterOperations from './operations';
import * as omniDynamicFilterTypes from './types';
import * as omniDynamicFilterActions from './actions';

export { omniDynamicFilterOperations, omniDynamicFilterTypes, omniDynamicFilterActions };

export default omniDynamicFilters;
